<template>
  <div id="populationRightThree" class="echarts"></div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  inject,
  watchEffect,
  nextTick,
} from "vue";
import * as echarts from "echarts";
import { populationType } from "@/api/dataAnalysis/populationAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      obj: [],
      regionId: 0,
    });
    const refData = toRefs(data);
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo && regionInfo.regionList) {
        nextTick(() => {
          initCharts();
        });
      }
    });
    const populationlist = async () => {
      let params = data.regionId;
      if (regionInfo && regionInfo.regionList.length > 0) {
        params = {
          regionIds: regionInfo.regionList.toString(),
        };
      }
      const res = await populationType(params);
      data.obj = [];
      res.data.forEach((v) => {
        data.obj.push({ value: v.value, name: v.name });
      });
      console.log(data.obj);
    };
    const initCharts = async () => {
      await populationlist();
      const myChart = echarts.init(
        document.getElementById("populationRightThree")
      );
      const option = {
        // title: {
        //   text: "Referer of a Website",
        //   subtext: "Fake Data",
        //   left: "center",
        // },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: "vertical",
        //   left: "left",
        // },
        series: [
          {
            // width: 380,
            // height: 260,
            type: "pie",
            radius: "50%",
            radius: ["30%", "55%"],
            data: data.obj,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart && myChart.setOption(option, true);
    };
    onMounted(async () => {
      if (!regionInfo) initCharts();

      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
    return {
      ...refData,
      populationlist,
    };
  },
});
</script>
<style  lang='scss' scoped >
#populationRightThree {
  // margin-top: 20px;
  width: 100%;
  height: 85%;
}
</style>